/* ==========================================================================
   <deferred-video> — SSS item 10, 2026-08-31
   Defined here because two files emit it (the video section and the product
   gallery) and neither owns it. Registered at top level, not inside
   $(document).ready: custom.js is deferred, and a custom element upgrades
   elements already in the DOM retroactively.

   The iframe lives in a <template>, whose contents the browser parses but
   does NOT fetch, and is cloned in on click. That is the Dawn deferred-media
   pattern and it is a spec guarantee, not a trick.
   ========================================================================== */
if (typeof customElements !== 'undefined' && !customElements.get('deferred-video')) {
  customElements.define('deferred-video', class extends HTMLElement {
    connectedCallback() {
      var poster = this.querySelector('.sss-dv__poster');
      if (!poster) return;
      poster.addEventListener('click', this.load.bind(this), { once: true });
    }
    load() {
      if (this.hasAttribute('loaded')) return;
      var tpl = this.querySelector('template');
      if (!tpl || !tpl.content.firstElementChild) return;
      var frame = tpl.content.firstElementChild.cloneNode(true);
      this.setAttribute('loaded', '');
      var poster = this.querySelector('.sss-dv__poster');
      if (poster) poster.remove();
      this.appendChild(frame);
      /* Land a keyboard user in the video they asked for. */
      try { frame.focus({ preventScroll: true }); } catch (e) {}
    }
  });
}

(function() {
  // Wait until jQuery and PXUTheme are ready
  $(document).ready(function() {

    // Check if window.PXUTheme exists to avoid errors
    if (window.PXUTheme && typeof window.PXUTheme.mobileMenu !== 'undefined') {

      // Override the isScreenSizeLarge function
      window.isScreenSizeLarge = function() {
        return $(window).width() > 1200; // instead of 768
      };

      // Trigger a resize to re-apply menu logic based on the new breakpoint
      $(window).trigger('resize');
    }

    // Product Slider Add to Cart Enhancement
    // The ajax-submit class automatically triggers the cart drawer functionality
    // from z__jsAjaxCart.js - no additional JavaScript needed!
    
    // Verify each add to cart button adds the correct product
    $(document).on('click', '.product-slider__add-to-cart-btn', function(e) {
      var $button = $(this);
      var $form = $button.closest('form');
      var productId = $button.data('product-id');
      var variantId = $button.data('variant-id');
      var productTitle = $button.data('product-title');
      var formVariantId = $form.find('input[name="id"]').val();
      
      // Debug logging to ensure correct product is being added
      console.log('=== Product Slider Add to Cart ===');
      console.log('Product ID:', productId);
      console.log('Product Title:', productTitle);
      console.log('Variant ID from button:', variantId);
      console.log('Variant ID from form:', formVariantId);
      console.log('Form ID:', $form.attr('id'));
      console.log('Form data:', $form.serialize());
      console.log('===================================');
      
      // Verify the form has the correct variant ID
      if (formVariantId != variantId) {
        console.error('WARNING: Variant ID mismatch!');
        console.error('Expected:', variantId, 'Got:', formVariantId);
      }
      
      // You can add custom analytics tracking here if needed
      // Example: ga('send', 'event', 'Product Slider', 'Add to Cart', productId);
    });

    // Optional: Handle any errors specific to product slider
    $(document).on('ajaxCart:error', '.product-slider__form', function(e, error) {
      console.error('Product slider cart error:', error);
      // You can add custom error handling here if needed
    });

  });
})();
